module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showPortionsModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Select a Portion")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable table-fixed-height"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(" Icon ")]), _vm._v(" "), _c('th', [_vm._v(" Name ")]), _vm._v(" "), _c('th', [_vm._v(" Multiplier ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.portions), function(portion) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "md-checkbox has-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (portion.selected),
        expression: "portion.selected"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": 'portion_checkbox_' + portion.id
      },
      domProps: {
        "checked": Array.isArray(portion.selected) ? _vm._i(portion.selected, null) > -1 : (portion.selected)
      },
      on: {
        "change": function($event) {
          var $$a = portion.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (portion.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (portion.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(portion, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'portion_checkbox_' + portion.id
      }
    }, [_c('span', {
      staticClass: "inc"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    })])])]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": portion.icon_url,
        "width": "30",
        "height": "30"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(portion.name) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(portion.multiplier) + " ")])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.applyPortionsToItem()
      }
    }
  }, [_vm._v("Apply Portions")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f04e7c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Portions/PortionsList.vue
// module id = 704
// module chunks = 0